<!-- <button mat-button (click)="onNoClick()">Close</button> -->
<img style="margin-left: 1%;" src="../../assets/close_box.png" (click)="closePopup()" alt="Close"/>
<img src="{{EncodedImageURL}}" alt="FAQ image"/>